export const resolveCourseId = (state, explicitCourseId) => {
    const courseId = explicitCourseId || state.courseList?.courseId || state.courseModule?.course_id;
    if (!courseId) {
        throw new Error('No enrolled course is selected.');
    }
    return courseId;
};

export const resolveModuleSlug = (moduleSlug) => {
    if (!moduleSlug) {
        throw new Error('No course module is selected.');
    }
    return encodeURIComponent(moduleSlug);
};

export const getQuizQuestionText = (question) => {
    if (typeof question === 'string') return question;
    return question?.quiz_question || question?.question || '';
};

export const getKeypointList = (keypoints) => {
    if (Array.isArray(keypoints)) return keypoints.filter(Boolean);
    if (typeof keypoints === 'string') return keypoints.split('\n').filter(Boolean);
    return [];
};

export const getAssessmentLines = (assessment) => {
    if (!assessment) return [];
    if (typeof assessment === 'string') return assessment.split('\n').filter(Boolean);

    return [
        assessment.feedback,
        ...(assessment.strengths || []).map((item) => `Strength: ${item}`),
        ...(assessment.improvements || []).map((item) => `Improve: ${item}`),
    ].filter(Boolean);
};

const getAssessmentItems = (items) => {
    if (Array.isArray(items)) return items.filter(Boolean);
    if (typeof items === 'string' && items.trim()) return [items];
    return [];
};

export const getAssessmentContent = (assessment) => {
    if (!assessment) return null;

    if (typeof assessment === 'string') {
        return assessment.trim()
            ? { type: 'text', feedback: assessment, strengths: [], improvements: [] }
            : null;
    }

    const feedback = typeof assessment.feedback === 'string' ? assessment.feedback : '';
    const strengths = getAssessmentItems(assessment.strengths);
    const improvements = getAssessmentItems(assessment.improvements);

    if (!feedback && strengths.length === 0 && improvements.length === 0) return null;

    return { type: 'structured', feedback, strengths, improvements };
};
